import axios from 'axios';
import { FilterObject } from '@bludata/hook-usetableloader';
import { SortObject } from '@bludata/hook-usetableloader';
import { QueryClient } from '@tanstack/react-query';

interface InfoQuery {
  filters?: FilterObject[];
  sorters?: SortObject[];
}

//!RIORDINA LE CHIAVI DI UN OGGETTO IN MODO CHE ANCHE OGGETTI UGUALI CON CHIAVI DISORDINATE RISULTINO IDENTICI
function orderKeys(obj: any) {
  const keys = Object.keys(obj).sort(function keyOrder(k1, k2) {
    if (k1 < k2) return -1;
    else if (k1 > k2) return +1;
    else return 0;
  });

  let i;
  const after: any = {};
  for (i = 0; i < keys.length; i++) {
    after[keys[i]] = obj[keys[i]];
    delete obj[keys[i]];
  }

  for (i = 0; i < keys.length; i++) {
    obj[keys[i]] = after[keys[i]];
  }
  return obj;
}

const getQueryCachingObject = (
  tablename: string,
  filters: FilterObject[],
  sorters: SortObject[],
  api?: string,
  customCacheKey?: string, //?PERMETTE DI DEFINIRE UNA CHIAVE DI CACHE CUSTOM, UTILE PER CACHARE QUERY PER LA STESSA TABELLA, AD ESEMPIO FORNITORE_MAGAZZINO_MONTATURE E FORNITORE_MAGAZZINO_LAC CHE HANNO LA STESSA TABELLA
  replaceCachedKey?: string[]
) => {
  const apipath = api || 'focusapi';
  const cacheKey = customCacheKey || tablename;
  let queryKey: any[] = [`table_${cacheKey}_cached`];

  if (apipath !== 'focusapi') {
    queryKey[0] = `${queryKey[0]}_${apipath}`;
  }

  const infoObj: InfoQuery = {};
  const filtersDefined = filters && filters.length > 0;
  const sortersDefined = sorters && sorters.length > 0;

  if (filtersDefined || sortersDefined) {
    if (filtersDefined) {
      infoObj.filters = filters.map((filter) => orderKeys(filter));
    }

    if (sortersDefined) {
      infoObj.sorters = sorters.map((sorter) => orderKeys(sorter));
    }

    queryKey.push(infoObj);
  }

  if (replaceCachedKey && replaceCachedKey.length > 0) {
    queryKey = replaceCachedKey;
  }

  const queryClient = new QueryClient();
  const cachedData = queryClient.getQueryData(queryKey) as any[];

  return {
    queryKey,
    queryFn: () =>
      axios
        .get(`/${apipath}/tabella/${tablename}`, {
          params: {
            page: 0,
            start: 0,
            limit: 9999999,
            sort: infoObj.sorters ? JSON.stringify(sorters) : null,
            filter: infoObj.filters ? JSON.stringify(filters) : null,
          },
        })
        .then((res): any[] => res?.data?.data || []),
    placeholderData: cachedData || [],
  };
};

export default getQueryCachingObject;
